<div class="container mx-auto device-content">
    <div class="hero-text" fxLayout="row" fxFlexAlign="center">
        <h1 style="font-weight:800;">{{"DEVICE_COMPANY_UPDATE" |translate}}</h1>
    </div>
    <form #deviceCompanyForm="ngForm" >
        <div fxLayout="row wrap" fxFlexAlign="center">
            <div fxFlex="100" fxLayout="column" fxLayoutAlign="space-evenly start">
                <mat-form-field appearance="outline" floatLabel="always" class="w-100-p">
                    <mat-label>{{'COMPANY'|translate}}</mat-label>
                    <mat-select [(ngModel)]="selectedCompany" placeholder="{{'COMPANY'|translate}}" required
                        name="companies">
                        <mat-option *ngFor="let item of companyList" name="copaniesOptions" [value]="item.id">
                            {{item.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <button style="margin-top: 10px;" mat-raised-button (click)="submit(deviceCompanyForm)">
                <span>{{'CREATE'|translate}}</span>
            </button>
        </div>
    </form>

</div>